import { Injectable } from '@angular/core'
import { Resolve } from '@angular/router'

import { EstabelecimentoService } from './estabelecimento.service'

@Injectable()
export class TotalDeEstabelecimentosCarentesResolver
    implements Resolve<number> {
    constructor(private estabelecimentoService: EstabelecimentoService) {}

    resolve() {
        return this.estabelecimentoService.obterTotalDeCarentes()
    }
}



// WEBPACK FOOTER //
// ./src/app/estabelecimentos/shared/total-de-estabelecimentos-carentes.resolver.ts